[
    {
        "id": "1",
        "fname": "Admin",
        "lname": "",
        "email": "test@test.com",
        "phone": "admin",
        "password": "admin",
        "employeedOn": "12-12-1212",
        "role": "Admin",
        "profilePic": "",
        "aadhar": "",
        "address": "",
        "city": "",
        "state": "",
        "pin": "",
        "gender": "",
        "dob": "",
        "country": "",
        "emailVerified": "",
        "phoneVerified": "",
        "maritalStatus": "",
        "permanentAddress": "",
        "jobTitle": "",
        "department": "",
        "employeeType": "",
        "manager": "",
        "officeLocation": "",
        "higestEdu": "",
        "eduBg": "",
        "bankName": "",
        "bankAccNo": "",
        "BankAccType": "",
        "bankAccBranch": "",
        "bankAccBranchIFSC": "",
        "aadharNo": "",
        "panNo": "",
        "salaryDate": "",
        "salary": "",
        "isActive": "",
        "createdAt": "",
        "deletedAt": "",
        "delReason": "",
        "lastLogin": "",
        "action": ""
    },
    {
        "fname": "Vaibhav",
        "lname": "Mojad",
        "email": "vaibhav@test.com",
        "phone": "9898989898",
        "password": "user123",
        "profilePic": null,
        "aadhar": null,
        "address": "Near lonawala",
        "city": "Pune",
        "state": "Maharashtra",
        "pin": "123123",
        "gender": null,
        "dob": "1997-12-01",
        "country": "India",
        "emailVerified": null,
        "phoneVerified": null,
        "maritalStatus": null,
        "permanentAddress": null,
        "jobTitle": "Sr Analyst",
        "department": "Marketing",
        "employeeType": "Full",
        "manager": "Amol",
        "officeLocation": "Narhe",
        "higestEdu": "MTech",
        "eduBg": null,
        "bankName": "ICICI",
        "bankAccNo": "987654321234",
        "BankAccType": "Salaried",
        "bankAccBranch": "Shivajinagar",
        "bankAccBranchIFSC": "ICIC000099821",
        "aadharNo": "123345647897",
        "panNo": "ADDES8789G",
        "salaryDate": "05",
        "salary": 120000,
        "employeedOn": "2024-05-12",
        "role": "Sr Analyst",
        "isActive": 1,
        "id": 1749928025586,
        "createdBy": "1",
        "createdAt": 1749928025586,
        "updatedBy": null,
        "updatedAt": null,
        "deletedBy": null,
        "deletedAt": null,
        "deletedReason": null
    }
]
